import {
  styled,
  Dialog,
  dialogClasses,
  DialogContent,
  DialogActions,
  Button,
  Card,
  cardHeaderClasses,
  cardContentClasses,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { lighten } from '@mui/material/styles';

export const DialogGenerateLiquidationContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 800,
    width: '100%',
    minHeight: 631,
  },
});

export const DialogGenerateLiquidationLoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  flex: 1,
});

export const DialogGenerateLiquidationContentContainer = styled(DialogContent)(
  ({ theme }) => ({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing(2),
  }),
);

export const DialogGenerateLiquidationSummaryCard = styled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
    gap: theme.spacing(1),
  }),
);

export const DialogGenerateLiquidationGenerateDataCard = styled(Card)(
  ({ theme }) => ({
    backgroundColor: lighten(theme.palette.success.main, 0.9),
    padding: theme.spacing(3),
    width: '100%',
    maxWidth: 500,

    [`& .${cardHeaderClasses.root}`]: {
      padding: 0,

      [`& .${cardHeaderClasses.avatar}`]: {
        fontSize: theme.typography.pxToRem(40),
        color: theme.palette.success.dark,
      },

      [`& .${cardHeaderClasses.title}`]: {
        ...theme.typography.h6,
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.success.dark,
      },
    },

    [`& .${cardContentClasses.root}`]: {
      padding: 0,
      paddingTop: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),

      '&:last-child': {
        paddingBottom: theme.spacing(0),
      },
    },
  }),
);

export const DialogGenerateLiquidationActions = styled(DialogActions)({
  justifyContent: 'space-between',
});

export const DialogGenerateLiquidationActionsButton = styled(Button)({
  minWidth: 100,
});

export const DialogGenerateLiquidationActionsButtonLoading = styled(
  LoadingButton,
)({
  minWidth: 100,
});
